import { autorun, when } from 'mobx';
import { once } from '../../js/utils';
import { AnalyticsStore } from '../AnalyticsStore';
import { MraidStore } from '../MraidStore';
import { TimerStore } from '../TimerStore';

const DELAY = 1000;
const THRESHOLD = 50;

interface Mrc50TrackHandlerProps {
  mraidStore: MraidStore;
  analyticsStore: AnalyticsStore;
  formatConfig: any;
}

export class Mrc50TrackHandler {
  mraidStore: MraidStore;
  timerStore: TimerStore;
  analyticsStore: AnalyticsStore;
  formatConfig: any;

  isViewable: boolean = false;

  constructor({
    mraidStore,
    analyticsStore,
    formatConfig
  }: Mrc50TrackHandlerProps) {
    this.mraidStore = mraidStore;
    this.analyticsStore = analyticsStore;
    this.formatConfig = formatConfig;
    this.timerStore = new TimerStore({ delay: DELAY });
    this.handle = once(this.handle);

    if (!this.hasTrackers()) {
      return;
    }

    autorun(() => {
      if (this.timerStore.isFinished) return;

      const isViewable = this.mraidStore.exposure >= THRESHOLD;
      if (isViewable === this.isViewable) return;

      this.isViewable = isViewable;
      if (isViewable) {
        this.timerStore.resume();
      } else {
        this.timerStore.pause();
      }
    });

    when(
      () => this.timerStore.isFinished,
      () => this.handle()
    );
  }

  handle() {
    const imgTrackers = this.formatConfig?.mrc50ImgTrackers || [];
    const jsTrackers = this.formatConfig?.mrc50JsTrackers || [];
    imgTrackers.forEach((url: string) => this.analyticsStore.sendTrack(url));
    jsTrackers.forEach((url: string) => this.analyticsStore.sendJsTrack(url));
  }

  private hasTrackers(): boolean {
    return (
      this.formatConfig?.mrc50ImgTrackers?.length > 0 ||
      this.formatConfig?.mrc50JsTrackers?.length > 0
    );
  }
}
